
<template>
    <div>
        <div class='row justify-center full-width q-pa-md'>
            <q-tabs two-lines style='width:100%' inverted color="primary" animated>
                <!-- Tabs - notice slot="title" -->
                <q-tab default slot="title" name="tab-1" icon="accessibility"  label='Компания'/>
                <q-tab  slot="title" name="tab-2" icon="account_box" label='пользователи' />
                <q-tab  slot="title" name="userPays" icon="fas fa-ruble-sign" label='Оплаты' />
 
                <!-- Targets -->
                <q-tab-pane name="tab-1">

                    <div class='q-ma-xs q-mt-lg row no-wrap justify-between' style='margin-bottom:55px;'>
                        <q-input v-model='form.companyName' float-label="Название организации" style='width:75%' @keydown="(key)=>{if (key.key=='Enter') saveCompanyName();}"/>
                        <q-btn icon='save' label='Сохранить' color='green' class='q-mr-lg gt-xs' :disable="!isNeedSave" @click="saveCompanyName" :loading="changeCompanyNameLoading" style='max-width:150px;'/>
                        <q-btn icon='save' color='green' class='lt-sm' :disable="!isNeedSave" @click="saveCompanyName" :loading="changeCompanyNameLoading" style='width:50px;'/>
                    </div>
                    <div class='q-title text-primary'>
                        <div class="row">
                            <q-icon name='fas fa-clipboard-list' class='q-mr-md'/>
                            <div >cписок организаций</div>
                        </div>
                        <div class='org-container'>
                            <div class='row no-wrap ellipsis justify-around'>
                                 <q-input v-model="form.newOrgName" class='q-mb-lg' float-label="новое юр.лицо" style='width:65%' @keydown="(key)=>{ if (key.key=='Enter') addNewOrg();}"/>
                                 <div class='q-pa-md ellipsis' v-if='this.editedId == -1'>
                                        <q-btn icon='add' class='gt-xs' label='добавить' color='green' inverted @click = 'addNewOrg' :loading="newOrgLoading" style='width:150px'/>
                                        <q-btn icon='add' class='lt-sm' color='green' inverted @click = 'addNewOrg' :loading="newOrgLoading" style='width:50px'/>
                                 </div>
                                 <div class='q-pa-md ellipsis' v-if='this.editedId != -1'>
                                        <q-btn icon='save' label='сохранить' class='gt-xs' color='green' inverted @click = 'addNewOrg' :loading="newOrgLoading" style='width:90px'/>
                                        <q-btn icon='cancel' class='q-ml-sm gt-xs' label='отмена' color='negative' inverted @click = 'cancelEdit' :loading="newOrgLoading" style='width:90px'/>
                                        <q-btn icon='save' class='lt-sm' color='green' inverted @click = 'addNewOrg' :loading="newOrgLoading" style='width:30px'/>
                                        <q-btn icon='cancel' class='q-ml-md lt-sm'   color='negative' inverted @click = 'cancelEdit' :loading="newOrgLoading" style='width:30px'/>

                                 </div>


                            </div>
                            <div class="org-item-container">
                                <div v-for="(org, key) in organizations" :key=key>
                                    <div class='org-item bg-grey-2 q-pa-sm ellipsis q-subheading text-black'>
                                        <q-btn icon='far fa-trash-alt' dense flat  class='q-mr-sm' color='negative' size='md' @click='deleteOrg(org)'/>
                                        <q-btn icon='edit' dense flat  class='q-mr-sm' color='primary' size='md' @click='editOrg(org)'/>
                                        {{org.name}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </q-tab-pane>
                <q-tab-pane name="tab-2">
                    <users/>
                </q-tab-pane>
                <q-tab-pane name='userPays'>
                    <userPays/>
                </q-tab-pane>
            </q-tabs>
        </div>

    </div>
</template>

<script>
/* eslint-disable */
import users from './../users/users';
import userPays from './userPays';

export default {
    
    name : 'tuning',

    components : {
        users,
        userPays,
    },

    data() {
        return {
            form : {
                companyName : '',
                newOrgName : '',
            },
            newOrgLoading : false,
            changeCompanyNameLoading : false,
            oldCompanyName : '',
            editedId : -1,
        }
    },
    created() {

        if (this.$store.getters.getMyCompany == null) {
            this.$store.dispatch('retrieveUsers')
            .then(()=> {
                this.form.companyName = this.$store.getters.getMyCompany.name;
                this.oldCompanyName = this.form.companyName;
            })
            .catch();
        } else {
             this.form.companyName = this.$store.getters.getMyCompany.name;
             this.oldCompanyName = this.form.companyName;
        }

        if (this.$store.getters.getAllOrganization.length == 0) {
            this.$store.dispatch('getOrganization');
        }

    },

    computed : {
        isNeedSave() {
            return this.oldCompanyName != this.form.companyName.trim();
        },

        organizations() {
            let q = this.$store.getters.getAllOrganization;
            return q;
        },
    },
    methods : {
        cancelEdit() {
            this.editedId = -1;
            this.form.newOrgName = '';
        },

        editOrg(org) {
            this.editedId = org.id;
            this.form.newOrgName = org.name;
        },

        deleteOrg(org) {
           this.$q.dialog({
               title : 'Внимание!',
               message : 'Действительно удалить юр.лицо "'+org.name+'"?',
               color : 'primary',
               ok : 'Да, удалить',
               cancel : 'Нет, я передумал',
               stackButtons: true,
           })
           .then(()=>{
               this.$store.dispatch('deleteOrg', org.id)
               .then(()=>{
                   this.$admns.showNotify('Запись удалена','success','Сообщение системы');
               })
               .catch();
           })
           .catch();
        },

        saveCompanyName() {
            // проверяем валидность ввода
            let q = this.form.companyName.trim();
            this.form.companyName = q;
            if (this.form.companyName.length == 0) {
                this.$admns.showNotify('Название компании не может быть пустым','error','Сообщение системы');
                return;
            }
            //начинаем процедуру сохранения
            this.changeCompanyNameLoading = true;
            this.$store.dispatch('updateCompanyName', {name : this.form.companyName})
            .then(()=> {
                this.oldCompanyName = this.form.companyName;
                this.changeCompanyNameLoading = false;
                this.$admns.showNotify('Название компании сохранено','success','Сообщение системы');
            })
            .catch(()=>{
                this.$admns.showNotify('Ошибка при сохранении названия компании','error','Сообщение системы');
                this.changeCompanyNameLoading = false;
            });

        },

        addNewOrg() {
            this.newOrgLoading = true;
            let q = this.form.newOrgName.trim();
            if (q.length > 0) { // если прошло проверку
                this.$store.dispatch('addNewOrg', {name:q, id: this.editedId})
                .then(()=>{
                    this.newOrgLoading = false;
                    this.form.newOrgName = '';
                    this.editedId = -1;
                })
                .catch((error)=> {
                    console.log(error);
                    this.newOrgLoading = false;
                });
            }
            else { //ошибка
                this.newOrgLoading = false;
                this.$admns.showNotify('Введите новое юр.лицо','error','Сообщение системы');
            }
        }
      
    }

}
</script>

<style lang="scss" scoped>
  .org-container {
      border : 1px solid lightgray;
      border-radius : 3px;
      margin-top : 10px;
      padding : 10px;
  }
  .org-item {
      border : 1px solid lightgray;
      border-radius: 2px;
      margin-top : 1px;
      cursor: pointer;
      &:hover {
          background : rgb(170, 255, 170) !important;
      }
  }
  .org-item-container {
      max-height: 300px;
      overflow : auto;
      padding : 10px;
      border : 1px dotted lightgray;
      border-radius: 2px;

  }
</style>
